"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _permission = require("@/utils/permission");
var _utils = require("@/utils");
var merchant = _interopRequireWildcard(require("@/api/merchant"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'MerchantSupplier',
  data: function data() {
    return {
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      // 类型列表数据
      typeList: [],
      tableFrom: {
        page: 1,
        limit: 20,
        orderNo: '',
        // 订单号
        supplierName: '',
        // 供应商名称
        linkman: '',
        // 联系人
        phone: '',
        // 联系方式
        orderUser: '',
        // 用户ID
        orderStatus: '-1',
        // 订单状态，-1表示全部
        type: '',
        // 类型
        isRefund: '' // 是否退款
      },
      // 审核弹窗数据
      auditDialog: {
        visible: false,
        loading: false,
        form: {
          id: '',
          cause: ''
        },
        rules: {
          cause: [{
            required: false,
            message: '请输入审核备注',
            trigger: 'blur'
          }]
        }
      },
      // 防抖定时器
      auditTimer: null,
      // 退款弹窗数据
      refundDialog: {
        visible: false,
        loading: false,
        orderId: ''
      }
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:merchant:supplier:page:list'])) {
      this.getTypeList(); // 先获取类型列表
      this.getList();
    }
  },
  beforeDestroy: function beforeDestroy() {
    // 清理定时器
    if (this.auditTimer) {
      clearTimeout(this.auditTimer);
    }
  },
  methods: {
    checkPermi: _permission.checkPermi,
    /**
     * 获取类型列表
     */
    getTypeList: function getTypeList() {
      var _this = this;
      merchant.merchantTypeListApi().then(function (res) {
        if (res && res.list && Array.isArray(res.list)) {
          _this.typeList = res.list;
        } else {
          _this.typeList = [];
        }
      }).catch(function (error) {
        console.error('获取类型列表失败:', error);
        _this.typeList = [];
      });
    },
    /**
     * 根据类型ID获取类型名称
     */
    getTypeName: function getTypeName(typeId) {
      if (!typeId || !this.typeList.length) return '--';
      var type = this.typeList.find(function (item) {
        return item.id == typeId;
      });
      return type ? type.name : '--';
    },
    /**
     * 计算实付款金额
     * @param {Object} row - 行数据
     * @returns {string} 实付款金额，保留2位小数
     */
    getActualPayment: function getActualPayment(row) {
      try {
        // 获取保证金金额，处理空值和类型转换
        var productPrice = row.productPrice ? parseFloat(row.productPrice) : 0;

        // 获取抵扣券金额，处理空值和类型转换
        var balance = row.balance ? parseFloat(row.balance) : 0;

        // 计算实付款：保证金 - 抵扣券金额
        var actualPayment = productPrice - balance;

        // 确保实付款不小于0
        var finalAmount = Math.max(0, actualPayment);

        // 返回保留2位小数的金额字符串
        return finalAmount.toFixed(2);
      } catch (error) {
        console.error('计算实付款失败:', error);
        return '0.00';
      }
    },
    /**
     * 获取列表数据
     */
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      var params = {
        pageNum: this.tableFrom.page,
        pageSize: this.tableFrom.limit,
        orderNo: this.tableFrom.orderNo || undefined,
        supplierName: this.tableFrom.supplierName || undefined,
        linkman: this.tableFrom.linkman || undefined,
        phone: this.tableFrom.phone || undefined,
        orderUser: this.tableFrom.orderUser || undefined,
        orderStatus: this.tableFrom.orderStatus !== '-1' ? this.tableFrom.orderStatus : undefined,
        type: this.tableFrom.type || undefined,
        isRefund: this.tableFrom.isRefund || undefined
      };

      // 调用供应商列表接口
      merchant.supplierOrderListApi(params).then(function (res) {
        // res 直接是数据对象
        if (res && res.list && Array.isArray(res.list)) {
          _this2.tableData.data = res.list;
          _this2.tableData.total = res.total || 0;
        } else {
          _this2.tableData.data = [];
          _this2.tableData.total = 0;
        }
      }).catch(function (error) {
        console.error('获取供应商列表失败:', error);
        _this2.$message.error('获取数据失败');
      }).finally(function () {
        _this2.listLoading = false;
      });
    },
    /**
     * 重置搜索条件
     */
    reset: function reset() {
      this.tableFrom = {
        page: 1,
        limit: 20,
        orderNo: '',
        supplierName: '',
        linkman: '',
        phone: '',
        orderUser: '',
        orderStatus: '-1',
        type: '',
        isRefund: ''
      };
      this.getList();
    },
    /**
     * 审核操作
     */
    handleAudit: function handleAudit(row) {
      // 打开审核弹窗
      this.auditDialog.form = {
        id: row.id,
        cause: ''
      };
      this.auditDialog.visible = true;
    },
    /**
     * 提交审核
     */
    submitAudit: function submitAudit(action) {
      var _this3 = this;
      // 不通过时，备注必填
      if (action === 'reject' && !this.auditDialog.form.cause.trim()) {
        this.$message.warning('不通过时，审核备注不能为空');
        return;
      }

      // 防抖处理
      if (this.auditTimer) {
        clearTimeout(this.auditTimer);
      }
      this.auditTimer = setTimeout(function () {
        _this3.doSubmitAudit(action);
      }, 500);
    },
    /**
     * 执行审核提交
     */
    doSubmitAudit: function doSubmitAudit(action) {
      var _this4 = this;
      this.auditDialog.loading = true;
      var actionText = action === 'pass' ? '通过' : '不通过';

      // 调用审核接口
      var auditData = {
        id: this.auditDialog.form.id,
        cause: this.auditDialog.form.cause || '',
        orderStatus: action === 'pass' ? 2 : 3 // 2=通过, 3=审核拒绝
      };
      merchant.supplierOrderAuditApi(auditData).then(function (res) {
        _this4.$message.success(res);
        _this4.auditDialog.visible = false;
        _this4.getList(); // 刷新列表
      }).catch(function (error) {
        console.error('审核失败:', error);
        _this4.$message.error("\u5BA1\u6838".concat(actionText, "\u5931\u8D25"));
      }).finally(function () {
        _this4.auditDialog.loading = false;
      });
    },
    /**
     * 取消审核
     */
    cancelAudit: function cancelAudit() {
      this.auditDialog.visible = false;
      this.auditDialog.form.cause = '';
    },
    /**
     * tab点击事件
     */
    handleTabClick: function handleTabClick(tab) {
      this.tableFrom.orderStatus = tab.name;
      this.getList(1);
    },
    /**
     * 分页大小改变
     */
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    /**
     * 页码改变
     */
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    /**
     * 退款操作
     */
    handleRefund: function handleRefund(row) {
      this.refundDialog.orderId = row.id;
      this.refundDialog.visible = true;
    },
    /**
     * 确认退款
     */
    confirmRefund: function confirmRefund() {
      var _this5 = this;
      this.refundDialog.loading = true;

      // 调用退款接口
      merchant.supplierOrderRefundApi({
        id: this.refundDialog.orderId
      }).then(function (res) {
        _this5.$message.success('退款成功');
        _this5.refundDialog.visible = false;
        _this5.getList(); // 刷新列表
      }).catch(function (error) {
        console.error('退款失败:', error);
        _this5.$message.error('退款失败');
      }).finally(function () {
        _this5.refundDialog.loading = false;
      });
    },
    /**
     * 取消退款
     */
    cancelRefund: function cancelRefund() {
      this.refundDialog.visible = false;
      this.refundDialog.orderId = '';
    }
  }
};